import React from 'react';
import cx from 'classnames';
import ListeningStatus from './Global/ListeningStatus';
import {getUserData} from "../services/API";

export default function WordInterventionModal({ word, instructions, icon, useWordIcon, rightContent, rightContentTitle, showListeningStatus = true }) {
  let wordClasses = cx({
    'word': true,
    'longWord': word ? (word.length > 8) : false,
  });

  let containerClasses = cx({
    wordInterventionModal: true,
    vertical: getUserData().sessionData.isiPad,
  });

  let getRightContent = () => {
    if(rightContent && rightContentTitle){
      return (
        <div className="right customContent">
          <div className="instructions">{rightContentTitle}</div>
          {rightContent}
        </div>
      );
    } else if(rightContent){
      return rightContent;
    } else {
      return (
        <div className="right">
          <div className="instructions">{instructions}</div>
          <div className={wordClasses}>{word}</div>
          {showListeningStatus && <div className="listeningStatusWrapper"><ListeningStatus/></div>}
        </div>
      );
    }
  }

  return (
    <div className={containerClasses}>
      {icon && (
        <div className="left">
          <div className="icon">
            {icon && (
              <img
                className={`interventionIcon ${useWordIcon ? "smallIcon" : ""}`}
                src={icon}
                alt=""
              />
            )}
          </div>
        </div>
      )}
      {getRightContent()}
    </div>
  );
}